
































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { ConfiguracaoMedico } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import ConfiguracaoNotificacoesStore from '@/components/ConfiguracaoNotificacoes/Store/ConfiguracaoNotificacoesStore'

@Component({})
export default class ViewConfiguracaoNotificaoPerfil extends Vue {
  @Prop({ type: Object, required: true }) readonly notificacao!: ConfiguracaoMedico

  loadingRecebeEmailNotificacao: Boolean = false
  loadingRecebeWhatsappNotificacao: Boolean = false
  addLocalLoading: Boolean = false
  loadingAddEmail = null
  filteredNofiticacaoConfiguracoes: ConfiguracaoMedico[] = []

  get getNotificacaoNotificacoesStore() {
    return getModule(ConfiguracaoNotificacoesStore, this.$store)
  }

  async updateRecebeWhatsappNotificacao(newValue: boolean, notificacao: ConfiguracaoMedico) {
    const oldValue = notificacao.recebeNotificacaoViaWhatsApp
    if (newValue && !notificacao.celular) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Número de celular não pode ser vazio.',
        icon: 'warning',
        color: '#C62828',
        timeout: 5800,
      })
      notificacao.recebeNotificacaoViaWhatsApp = !oldValue
      this.$nextTick(() => {
        notificacao.recebeNotificacaoViaWhatsApp = oldValue
      })
      return
    }
    this.loadingRecebeWhatsappNotificacao = true
    notificacao.recebeNotificacaoViaWhatsApp = newValue
    await this.updateDadosNotificacao({
      userId: notificacao.id,
      celular: notificacao.celular,
      recebeNotificacaoViaWhatsApp: newValue,
    })
    this.loadingRecebeWhatsappNotificacao = false
  }

  async updateDadosNotificacao(config: Partial<ConfiguracaoMedico>) {
    const request = await this.getNotificacaoNotificacoesStore.alteraDadosNotificacao({
      ...config,
      celular: config.celular && config.celular.replace(/\D/g, ''),
    })
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message || 'Houve um erro no envio.',
        icon: 'warning',
        color: '#C62828',
        timeout: 5800,
      })
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Dados alterados com sucesso',
        icon: 'check_circle',
        color: '#43A047',
      })
    }
  }

  habilitarEdicaoCelular(notificacao: ConfiguracaoMedico) {
    notificacao.editandoCelular = true
  }

  async salvarCelular(notificacao: ConfiguracaoMedico) {
    notificacao.salvandoCelular = true
    if (!notificacao.celular) {
      notificacao.recebeNotificacaoViaWhatsApp = false
    }
    await this.updateDadosNotificacao({
      ...notificacao,
      userId: notificacao.id,
      celular: notificacao.celular.replace(/\D/g, ''),
      recebeNotificacaoViaWhatsApp: notificacao.recebeNotificacaoViaWhatsApp,
    })
    notificacao.salvandoCelular = false
    notificacao.editandoCelular = false
  }

  cancelarEdicaoCelular(notificacao: ConfiguracaoMedico) {
    notificacao.celular = notificacao.celularOriginal
    notificacao.editandoCelular = false
  }
}
